<template>
  <a-form
    id="my_form_styl"
    :label-col="{
      span: 12,
    }"
    :wrapper-col="{
      span: 12,
    }"
    :form="form"
  >
    <div
      style="text-align: center; font-weight: 700"
      v-show="document.invoiceAutoNumber"
    >
      {{ document.invoiceAutoNumber }} | {{ document.invoiceTitle }}
    </div>
    <a-form-item
      :label="$t('File name')"
      style="margin-top: 10px; border-top: 1px solid #d3d3d3"
    >
      <a-tooltip>
        <template slot="title">
          <span>{{ document.NAME }}</span>
        </template>
        <span>{{ document.NAME }}</span>
      </a-tooltip>
    </a-form-item>

    <a-form-item :label="$t('Status')">
      <a-tag style="font-weight: bold" :color="statusTag.color">{{
        $t(document.status)
      }}</a-tag>
    </a-form-item>
    <template v-if="profile.ADMIN">
      <a-form-item :label="$t('Main Company')">
        <!--<a-select
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'my_company',
            { rules: [{ required: false }], initialValue: document.my_company },
          ]"
        >
          <a-select-option
            v-for="(comp, id) in MY_COMPANY_LIST"
            :key="id"
          >{{
            comp["TITLE"]
          }}</a-select-option>
        </a-select>-->
        <a-input
          @change="changePromptStatus"
          @click="handleChangeMyCompany()"
          v-model="myCompanyTitle"
        />
      </a-form-item>

      <a-form-item :label="$t('Contractor')">
        <!--<a-select
          showSearch
          optionFilterProp="children"
          @change="handlerChangeContractor"
          v-decorator="[
            'kontragent',
            { rules: [{ required: false }], initialValue: document.kontragent },
          ]"
        >
          <a-select-option
            v-for="(comp, id) in COMPANY_LIST"
            :key="id"
          >{{
            comp["TITLE"]
          }}</a-select-option>
        </a-select>-->
        <a-input
          @change="changePromptStatus"
          @click="handleChangeContractor()"
          v-model="contactorTitle"
        />
      </a-form-item>

      <a-form-item :label="$t('Bank account')">
        <div style="display: flex">
          <a-auto-complete
            :data-source="bankAccountList"
            :filter-option="filterOption"
            v-decorator="[
              'bankAccount',
              {
                rules: [{ required: false }],
                initialValue: document.bankAccount,
              },
            ]"
          />
          <a-button @click="addBankAccount" type="primary" icon="plus" />
        </div>
      </a-form-item>
      <a-form-item :label="$t('Invoice number')">
        <a-input
          v-decorator="[
            'num_invoice',
            { rules: [{ required: false }], initialValue: document.num_doc },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('Type')">
        <a-select
          @change="handlerInvoiceType"
          v-decorator="[
            'invoiceType',
            {
              rules: [{ required: false }],
              initialValue: document.invoiceType || 'Faktura Kosztowa',
            },
          ]"
        >
          <a-select-option key="Faktura Kosztowa"
            >{{ $t('Faktura Kosztowa') }}</a-select-option
          >
          <a-select-option key="Proforma">{{ $t('Proforma') }}</a-select-option>
          <a-select-option key="VAT Marza">{{ $t('Faktura do Proformy') }}</a-select-option>
          <a-select-option key="Korygujaca">{{ $t('Korygująca') }}</a-select-option>
          <a-select-option key="Faktura zaliczkowa"
            >{{ $t('Faktura zaliczkowa') }}</a-select-option
          >
          <a-select-option key="Faktura koncowa"
            >{{ $t('Faktura końcowa') }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item v-if="document.invoiceCorrection" :label="$t('Correction')">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>{{ document.invoiceCorrection }}</div>
          <a-button @click="showPreview" type="primary" icon="eye" />
        </div>
      </a-form-item>

      <a-form-item :label="$t('Payment')">
        <a-col :span="11">
          <a-select
            v-decorator="[
              'paymentType',
              {
                rules: [{ required: false }],
                initialValue: document.payment
                  ? document.payment.type
                  : 'Przelew',
              },
            ]"
          >
          <a-select-option key="Gotówka">{{  $t('Gotówka') }}</a-select-option>
          <a-select-option key="Przelew">{{  $t('Przelew') }}</a-select-option>
          <a-select-option key="Karta">{{  $t('Karta') }}</a-select-option>
          <a-select-option key="Pobranie">{{  $t('Pobranie') }}</a-select-option>
          <a-select-option key="Kompensata">{{  $t('Kompensata') }}</a-select-option>
          <a-select-option key="Barter">{{  $t('Barter') }}</a-select-option>
          <a-select-option key="Płatność przez Pracownika">{{  $t('Płatność przez Pracownika') }}</a-select-option>
          </a-select>
        </a-col>
      </a-form-item>
      <a-form-item :label="$t('Currency')">
        {{ document.currency.code }}
        <a-divider type="vertical" style="background: #d3d3d3" />
        {{ document.currency.val }}
      </a-form-item>
      <a-form-item :label="$t('Keywords')">
        <a-select
          mode="multiple"
          v-decorator="[
            'key_words',
            {
              rules: [{ required: false }],
              initialValue: document.key_words || [],
            },
          ]"
        >
          <a-select-option v-for="i in key_words" :key="i">{{
            i
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="$t('Tag')">
        <a-select
          :dropdownMatchSelectWidth="false"
          mode="tags"
          v-decorator="[
            'Teczka',
            { rules: [{ required: false }], initialValue: document.Teczka },
          ]"
        >
          <a-select-option v-for="i in info.teczkalist" :key="i">{{
            i
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="$t('Owner')">
        <span>{{ getCompanyAssign(document.my_company) }}</span>
      </a-form-item>

      <a-form-item :label="$t('Date of receiving')">
        <a-date-picker
          style="width: 100%"
          v-decorator="[
            'date_send',
            {
              rules: [{ required: false }],
              initialValue: document.date_send
                ? moment(document.date_send, 'YYYY-MM-DD')
                : '',
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('Date of issue')">
        <a-date-picker
          :format="YYYY - MM - DD"
          style="width: 100%"
          v-decorator="[
            'date_recept',
            {
              rules: [{ required: false }],
              initialValue: document.date_recept
                ? moment(document.date_recept, 'YYYY-MM-DD')
                : '',
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('Sale date')">{{
        document.saleDate
      }}</a-form-item>
      <a-form-item :label="$t('Date of payment')">
        <a-date-picker
          style="width: 100%"
          :format="YYYY - MM - DD"
          v-decorator="[
            'paymentDate',
            {
              rules: [{ required: false }],
              initialValue: document.paymentDate
                ? moment(document.paymentDate, 'YYYY-MM-DD')
                : '',
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('Planned date')">
        <a-date-picker
          style="width: 100%"
          :format="YYYY - MM - DD"
          v-decorator="[
            'plannedDate',
            {
              rules: [{ required: false }],
              initialValue: document.plannedDate
                ? moment(document.plannedDate, 'YYYY-MM-DD')
                : '',
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('Reminder')" class="last-block-item">
        <a-date-picker
          style="width: 100%"
          :format="YYYY - MM - DD"
          v-decorator="[
            'reminderDate',
            {
              rules: [{ required: false }],
              initialValue: document.reminderDate
                ? moment(document.reminderDate, 'YYYY-MM-DD')
                : '',
            },
          ]"
        />
      </a-form-item>
    </template>
    <template v-else>
      <a-form-item :label="$t('Main Company')">{{
        getCompany(document.my_company)
      }}</a-form-item>

      <a-form-item :label="$t('Contractor')">{{
        getCompany(document.kontragent)
      }}</a-form-item>

      <a-form-item :label="$t('Bank account')">{{
        document.bankAccount
      }}</a-form-item>
      <a-form-item :label="$t('Invoice number')">{{
        document.num_doc
      }}</a-form-item>
      <a-form-item :label="$t('Type')">{{ document.invoiceType }}</a-form-item>
      <a-form-item v-if="document.invoiceCorrection" :label="$t('Correction')">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>{{ document.invoiceCorrection }}</div>
          <a-button @click="showPreview" type="primary" icon="eye" />
        </div>
      </a-form-item>
      <a-form-item :label="$t('Payment')">
        <a-col :span="12">{{ document.payment.type }}</a-col>
        <a-col :span="12">{{ document.payment.date }}</a-col>
      </a-form-item>

      <a-form-item :label="$t('Currency')">
        {{ document.currency.code }}
        <a-divider type="vertical" style="background: #d3d3d3" />
        {{ document.currency.val }}
      </a-form-item>

      <a-form-item :label="$t('Keywords')">
        <a-tag v-for="(item, index) in document.key_words" :key="index">{{
          item
        }}</a-tag>
      </a-form-item>

      <a-form-item :label="$t('Tag')">
        <a-tag v-for="(item, index) in document.Teczka" :key="index">{{
          item
        }}</a-tag>
      </a-form-item>

      <a-form-item :label="$t('Owner')">
        <span>{{ getCompanyAssign(document.my_company) }}</span>
      </a-form-item>

      <a-form-item
        :label="$t('Date of receiving')"
        style="margin-top: 50px; border-top: 1px solid #d3d3d3"
        >{{ document.date_send }}</a-form-item
      >

      <a-form-item :label="$t('Date of issue')">{{
        document.date_recept
      }}</a-form-item>

      <a-form-item :label="$t('Sale date')">{{
        document.saleDate
      }}</a-form-item>

      <a-form-item :label="$t('Date of payment')">{{
        document.paymentDate
      }}</a-form-item>

      <a-form-item :label="$t('Planned date')">{{
        document.plannedDate
      }}</a-form-item>
      <a-form-item :label="$t('Reminder')">{{
        document.reminderDate
      }}</a-form-item>
    </template>
    <a-divider
      :style="{
        'margin-top': '50px',
        'margin-bottom': '0px',
        color: PaymentColor,
      }"
      >{{ $t('Zapłata') }} </a-divider
    >
    <a-form-item
      :label="$t('Date of booking')"
      has-feedback
      @change="handlerChangePaymentDateReal"
      :validate-status="validatePaymentDateReal"
    >
      <a-date-picker
        :format="YYYY - MM - DD"
        v-decorator="[
          'PaymentDateReal',
          { rules: [{ required: false }], initialValue: moment() },
        ]"
      />
    </a-form-item>
    <a-form-item>
      <span slot="label">
        {{ $t("Kwota") }}
        <span>
          <a-tag color="cyan">{{ kwotaVals.paidPercent }}%</a-tag>
          <a-tag color="green">{{ kwotaVals.paidSum }}</a-tag>
        </span>
      </span>
      <div style="display: flex">
        <a-input-number
          style="flex: 1"
          :min="0"
          :disabled="disableFromResponsible"
          :max="kwotaVals.leftToPay"
          v-decorator="[
            'kwotaVal',
            { rules: [{ required: false }], initialValue: 0 },
          ]"
        />
        <a-button-group style="margin-left: 10px">
          <a-button
            type="primary"
            :disabled="disableFromResponsible"
            icon="plus"
            @click="() => handlerKwotaAdd()"
          />
          <a-button
            type="primary"
            icon="history"
            @click="kwotaHistoryVisible = !kwotaHistoryVisible"
          />
        </a-button-group>
      </div>
    </a-form-item>

    <a-timeline style="padding: 15px 0 0 25px" v-show="kwotaHistoryVisible">
      <a-timeline-item v-for="(item, index) in kwotaVals.history" :key="index">
        <a-row type="flex" justify="space-around" align="middle">
          <a-col :span="4">
            {{ item.date }}
          </a-col>
          <a-col :span="4">
            {{ item.payment }}
          </a-col>
          <a-col :span="4">
            {{ getUser(item.user) }}
          </a-col>
          <a-col :span="4">
            <a-button
              type="link"
              icon="delete"
              style="color: #ff4d4f"
              v-if="profile.ADMIN || profile.ID == item.user"
              @click="() => handlerKwotaDelete(index)"
            />
          </a-col>
        </a-row>
      </a-timeline-item>
    </a-timeline>

    <span style="background-color: #e6f7ff">
      <a-form-item
        :label="$t('Kwota Netto')"
        style="
          margin-top: 50px;
          border-top: 1px solid #d3d3d3;
          background-color: #e6f7ff;
        "
      >
        <a-statistic :precision="2" :value="document.Quota.Netto" />
      </a-form-item>
      <a-form-item :label="$t('Kwota Vat')" style="background-color: #e6f7ff">
        <a-statistic :precision="2" :value="document.Quota.Vat" />
      </a-form-item>
      <a-form-item
        :label="$t('Kwota Brutto')"
        style="background-color: #e6f7ff"
      >
        <a-statistic :precision="2" :value="document.Quota.Bruto" />
      </a-form-item>
    </span>
  </a-form>
</template>
<script>
import moment from "moment";
import { requestStep, getCurrency } from "@/requestFunc";

export default {
  props: [
    "document",
    "statusTag",
    "MY_COMPANY_LIST",
    "COMPANY_LIST",
    "USER_LIST",
    "disableFromResponsible",
    "info",
    "key_words",
    "responsible",
    "profile",
    "user_setup",
  ],
  data() {
    return {
      validatePaymentDateReal: "success",
      form: this.$form.createForm(this, { name: "form_4" }),
      kwotaHistoryVisible: false,
      kwotaVals: {},
      PaymentColor: "inherit",
      myCompany: "",
      contractor: "",
      myCompanyTitle: "",
      contactorTitle: "",
    };
  },
  computed: {
    bankAccountList() {
      let my_comp =
        this.form.getFieldValue("my_company") || this.document.my_company;
      if (this.user_setup.BankAccount && my_comp)
        return this.MY_COMPANY_LIST[my_comp][this.user_setup.BankAccount];
      return [];
    },
  },
  methods: {
    moment,
    getCompanyAssign(id) {
      let company = this.document.arrayCompany.find((x) => x.ID == id);
      return company ? company.ASSIGNED_BY_NAME : "";
    },
    getUser(id) {
      let user = this.document.userList.find((x) => x.ID == id);
      return user ? user.NAME + " " + user.LAST_NAME : "";
    },
    handleChangeMyCompany() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          this.myCompany = info.company[0].id.split("_")[1];
          this.myCompanyTitle = info.company[0].title;
          this.handlerChangeMainCompany(this.myCompany);
        }
      );
    },
    handleChangeContractor() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          this.contractor = info.company[0].id.split("_")[1];
          this.contactorTitle = info.company[0].title;
          this.handlerChangeContractor(this.contractor);
        }
      );
    },
    getCompany(id) {
      let company = this.document.arrayCompany.find((x) => x.ID == id);
      return company ? company.TITLE : "";
    },
    handlerKwotaDelete(index) {
      this.kwotaVals.history.splice(index, 1);
      this.updateKwota();
    },
    handlerChangePaymentDateReal(dateMoment, dateString) {
      if (this.kwotaVals.paidPercent < 100) {
        if (dateString) {
          this.validatePaymentDateReal = "success";
        } else {
          this.validatePaymentDateReal = "error";
        }
      }
    },
    handlerKwotaAdd() {
      let kwotaVal = +this.form.getFieldValue("kwotaVal");
      if (!kwotaVal) return;
      let payment = kwotaVal.toFixed(2);
      let date = this.form.getFieldValue("PaymentDateReal")
        ? moment(this.form.getFieldValue("PaymentDateReal")).format(
            "YYYY-MM-DD"
          )
        : 0;
      if (date && payment) {
        this.kwotaVals.history.push({
          date,
          payment,
          user: this.profile.ID,
        });
        this.form.setFieldsValue({
          PaymentDateReal: "",
          kwotaVal: "",
        });
        this.validatePaymentDateReal = "default";
        this.kwotaHistoryVisible = true;
        this.updateKwota();
      } else if (!date) {
        this.validatePaymentDateReal = "error";
      }
    },
    updateKwota() {
      this.kwotaVals.sum = +this.document.Quota.Netto;
      this.kwotaVals.paidSum = +this.kwotaVals.history
        .reduce((accum, curr) => accum + +curr.payment, 0)
        .toFixed(2);
      this.kwotaVals.paidPercent = +(
        (this.kwotaVals.paidSum * 100.0) /
        this.kwotaVals.sum
      ).toFixed(2);
      this.kwotaVals.leftToPay = +(
        this.kwotaVals.sum - this.kwotaVals.paidSum
      ).toFixed(2);
      this.kwotaVals.leftToPayPercent = +(
        100.0 - this.kwotaVals.paidPercent
      ).toFixed(2);
      if (this.kwotaVals.paidPercent >= 100.0) {
        this.$emit("handlerSaveDisabled", {
          invoiceChanged: true,
          isSaveDisabled: false,
        });
        this.PaymentColor = "inherit";
      } else {
        this.$emit("handlerSaveDisabled", {
          invoiceChanged: true,
          isSaveDisabled: true,
        });
        this.PaymentColor = "red";
      }
    },
    addBankAccount() {
      let val = this.form.getFieldValue("bankAccount");
      let comp = this.form.getFieldValue("kontragent");
      if (val && comp && this.user_setup.BankAccount) {
        let companyBankAccount = this.COMPANY_LIST[comp][
          this.user_setup.BankAccount
        ];

        if (!companyBankAccount) {
          companyBankAccount = [val];
        } else if (!companyBankAccount.includes(val)) {
          companyBankAccount.push(val);
        }
        let kk = {};
        kk[this.user_setup.BankAccount] = companyBankAccount;

        BX24.callMethod(
          "crm.company.update",
          {
            id: comp,
            fields: kk,
          },
          function (result) {
            if (result.error()) console.error(result.error());
            else {
              console.info(result.data());
            }
          }
        );
      }
    },
    handlerChangeContractor(e) {
      if (this.user_setup.BankAccount && e) {
        let comp = this.document.arrayCompany.find((x) => x.ID == e);
        this.bankAccountList = comp[this.user_setup.BankAccount] || [];
      } else {
        this.bankAccountList = [];
      }
    },
    submit(updateStatus) {
      this.form.validateFields((error, values) => {
        if (error) {
          console.error(error);
          return;
        }
        if (this.kwotaVals.paidPercent < 100) {
          updateStatus = false;
        }
        this.changeSpinning();
        var updateStatistic = false;
        requestStep(this.saveValues(values, updateStatus))
          .done((data) => {
            var res = JSON.parse(data);
            if (this.document.status != res.status)
              updateStatistic = {
                prev: this.document.status,
                next: res.status,
              };
            this.document.status = res.status;
            this.$message.success(this.$t("Invoice confirmation success"));
          })
          .fail((e) => {
            console.err(e);
            this.$message.error(this.$t("Error confirmation invoice"));
          })
          .always(() => {
            this.onback(this.document.ID, updateStatus, updateStatistic);
            this.changeSpinning();
          });
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleCurrencyCodeChange(e) {
      var curr = this.info.currency.find((x) => x.CURRENCY == e);
      if (!this.currencyDate || curr.CURRENCY == "PLN") {
        this.form.setFieldsValue({
          currencyVal: curr.AMOUNT,
        });
      } else {
        this.form.setFieldsValue({
          currencyCode: curr.CURRENCY,
        });
        this.handleSaleDateChange();
      }
    },
    handleSaleDateChange(e) {
      let code = this.form.getFieldValue("currencyCode");
      let date = e ? e : this.form.getFieldValue("PaymentDateReal");
      if (date) {
        date = moment(date).subtract(1, "days");
        this.currencyDate =
          date.isoWeekday() > 5
            ? date.subtract(date.isoWeekday() - 5, "days").format("YYYY-MM-DD")
            : date.format("YYYY-MM-DD");

        if (code != "PLN") {
          getCurrency({ code, date: this.currencyDate }).done((data) => {
            let res = JSON.parse(data);
            if (res.currency) {
              this.form.setFieldsValue({
                currencyVal: res.currency.rates[0]["mid"],
              });
              this.$message.success(this.$t("Currency updated"));
            }
          });
        }
      }
    },
    saveValues(values, updateStatus = false) {
      var format_moment = (date) =>
        date ? moment(date).format("YYYY-MM-DD") : "";
      let data = {
        run: "acceptationCEO",
        mainid: this.document.mainid,
        updateStatus,
      };
      let update = this.profile.ADMIN
        ? {
            my_company: this.myCompany,
            kontragent: this.contractor,
            bankAccount: values.bankAccount,
            num_invoice: values.num_invoice,
            invoiceType: values.invoiceType,
            payment: {
              type: values.paymentType,
              date: format_moment(values.paymentDate),
            },
            key_words: values.key_words,
            Teczka: values.Teczka,
            date_send: format_moment(values.date_send),
            date_recept: format_moment(values.date_recept),
            paymentDate: format_moment(values.paymentDate),
            plannedDate: format_moment(values.plannedDate),
            reminderDate: format_moment(values.reminderDate),
            PaymentDateReal: format_moment(values.PaymentDateReal),
            kwota: this.kwotaVals,
          }
        : {
            PaymentDateReal: format_moment(values.PaymentDateReal),
            kwota: this.kwotaVals,
          };
      for (let key in update) {
        if (
          key in this.document &&
          JSON.stringify(update[key]) != JSON.stringify(this.document[key])
        ) {
          update[key] = {
            old: this.document[key],
            new: update[key],
          };
        } else {
          delete update[key];
        }
      }
      Object.assign(data, update);
      return data;
    },
    checkChanged() {
      var kk = false;
      this.form.validateFields((err, values) => {
        for (let field of Object.entries(this.saveValues(values))) {
          if (
            typeof field[1] == "object" &&
            Object.keys(field[1]).includes("old")
          ) {
            kk = true;
            break;
          }
        }
      });
      return kk;
    },
    onback(idFile, updateStatus, updateStatistic) {
      let unshift = this.document.status != "ZAAKCEPTOWANE";
      this.$emit("onback", {
        visible_doc: true,
        unshift_elem: unshift,
        remove_elem: idFile,
        updateStatistic,
        updateStatus: !updateStatus,
      });
    },
    showPreview() {
      this.$emit("showPreview", false);
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
  },
  mounted() {
    this.contractor = this.document.kontragent;
    this.contactorTitle = this.getCompany(this.document.kontragent);
    this.myCompany = this.document.my_company;
    this.myCompanyTitle = this.getCompany(this.document.my_company);
    this.handlerChangeContractor(this.document.kontragent);
    this.kwotaVals = Object.assign({}, this.kwotaVals, this.document.kwota);
    if (!this.kwotaVals.history) this.kwotaVals["history"] = [];
    this.updateKwota();
    this.form = this.$form.createForm(this, { name: "form_3" });

    BX24.fitWindow();
  },
};
</script>

<style scoped>
</style>
